module.exports = __webpack_public_path__ + "static/media/Group 37.d0fa8d7c.svg";